import { QueryState } from 'src/app/core/models/query.model';
import { createTokenQueryServiceInstance } from 'src/app/core/services/query.service';
import { SignalStoreConfig } from 'src/app/shared/functions/store.functions';
import { IAreraGestore } from './arera-gestore.model';
import { ITableColumn } from 'src/app/core/models/table.model';

export const ARERAGESTORE_ENDPOINT = 'arera-gestore';
export const ARERAGESTORE_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(ARERAGESTORE_ENDPOINT);

export const areraGestoreStateConfig: SignalStoreConfig<QueryState<IAreraGestore>> = {
  initState: {
    list: [],
    sort: {
      field: 'idArera',
      direction: 'asc'
    }
  }
}

export const ARERAGESTORE_COLUMNS: ITableColumn[] = [
  {
    name: 'idArera',
    label: 'Id. ARERA',
    field: 'idArera',
    primaryKey: true,
  },
  {
    name: 'denominazione',
    label: 'Denominazione',
    field: 'denominazione',
  },
  {
    name: 'partitaIva',
    label: 'Partita IVA',
    field: 'partitaIva',
  },
];
